import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/Tooltip/tooltip.container"
    ).then((module) => ({
        default: module.TooltipContainer
    }))
);
